module.exports = __webpack_public_path__ + "static/media/zind_rugarama6.ec910111.jpg";